<div (click)="openHelpPanel()" class="need-help-tab">
    {{ tabText }}
</div>

<div [class]="isPanelOpen === true ? 'need-help-panel open' : 'need-help-panel'">
    <div class="align-close">
        <mat-icon (click)="closeHelpPanel()" class="closing-x">close</mat-icon>
    </div>
    <div class="space-footer">
        <ng-content></ng-content>

        <div class="panel-footer">
            <h4>Need Help?</h4>
            <p>
                Contact us at
                <a href="tel:+{{ this.tenantSupportPhoneUnformatted }}">{{ this.tenantSupportPhone }}</a>
                or email us at <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a
                >.
            </p>
        </div>
    </div>
</div>
